import * as React from "react";
import {} from "@blueprintjs/core";
import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import { useCommonHooks } from "../../hooks";

import { nameof } from "../../utils";
import { ReferentialItemDto } from "../../api";
import { useFunctionalDirectorRef } from "../../hooks/applicationHooks/useFunctionalDirectorRef";

export interface DirectionSelectProps
  extends Pick<
    IFGSelectInputProps<any>,
    | "requiredMark"
    | "visible"
    | "disabled"
    | "style"
    | "readonly"
    | "inline"
    | "noLabel"
  > {
  name: string;
  label?: string;
  loading?: boolean;
}

export const DirectionSelect: React.FunctionComponent<DirectionSelectProps> = ({
  name,
  label,
  loading = false,
  ...fgSelectInputProps
}) => {
  const { t } = useCommonHooks();
  const { dir, dirLoading } = useFunctionalDirectorRef();

  return (
    <FGSelectInput
      label={label || t("DirectionOrService")}
      name={name}
      items={dir}
      loading={dirLoading || loading}
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};

export default DirectionSelect;
